<template>
  <a href="#" class="bold-options-toggle" title="Bold options" @click.prevent="toggle">
    <span class="icon has-text-info">
      <i class="fa-solid" :class="modelValue ? 'fa-circle-ellipsis' : 'fa-ellipsis'"></i>
    </span>
  </a>
</template>

<script setup>
  const props = defineProps({
    modelValue: { type: Boolean, required: true },
  });

  const emit = defineEmits(["update:modelValue"]);

  function toggle() {
    emit("update:modelValue", !props.modelValue);
  }
</script>
